import { useLanguage } from "@/context/LanguageContext";
import { cn } from "@/lib/utils";

export const LanguageToggle = ({ className }) => {
  const { lang, setLang } = useLanguage();
  return (
    <div className={cn("inline-flex items-center rounded-full bg-secondary p-1", className)} data-testid="language-toggle">
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="language-toggle-en"
        aria-pressed={lang === "en"}
        className={cn(
          "rounded-full px-3 py-1 text-xs font-semibold transition-colors",
          lang === "en" ? "bg-primary text-primary-foreground shadow" : "text-muted-foreground hover:text-foreground"
        )}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLang("hi")}
        data-testid="language-toggle-hi"
        aria-pressed={lang === "hi"}
        className={cn(
          "rounded-full px-3 py-1 text-xs font-semibold transition-colors",
          lang === "hi" ? "bg-primary text-primary-foreground shadow" : "text-muted-foreground hover:text-foreground"
        )}
      >
        हिंदी
      </button>
    </div>
  );
};
